import { useMemo, useRef } from "react";

/** The two ways an open menu closes. */
export interface MenuCloser {
  /** Outside click, scroll, resize…: focus stays wherever the user put it. */
  dismiss: () => void;
  /** A choice, Escape or Tab: focus goes back to where the menu was opened from. */
  closeAndReturnFocus: () => void;
}

export function useMenuCloser(onClose: () => void, returnFocus: HTMLElement | null): MenuCloser {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  return useMemo(
    () => ({
      dismiss: () => onCloseRef.current(),
      closeAndReturnFocus: () => {
        onCloseRef.current();
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      },
    }),
    [returnFocus],
  );
}
